module.exports = __webpack_public_path__ + "static/media/123-up arrow.a86beffc.svg";